<template>
  <div class="px-4">
    <form @submit.prevent="onSubmit" @keydown="form.err.clear($event.target.name)">
      <b-row class="mb-3">
        <b-col md="4">
          <input-component label="First Name" :form="form" property="first_name" />
        </b-col>
        <b-col md="4">
          <input-component label="Last Name" :form="form" property="last_name" />
        </b-col>
        <b-col md="4">
          <select-component
            label="Role"
            :form="form"
            property="subrole_id"
            :values="subroles"
            display="description"
          />
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col md="4">
          <input-component
            :disabled="id?true:false"
            label="E-Mail Address"
            :form="form"
            property="email"
          />
        </b-col>
        <b-col md="4">
          <input-component label="Street" :form="form" property="street" />
        </b-col>
        <b-col md="4">
          <input-component label="City" :form="form" property="city" />
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col md="4">
          <select-component
            label="State"
            :form="form"
            property="state_id"
            :values="states"
            display="name"
          />
        </b-col>
        <b-col md="4">
          <input-component label="Zip Code" :form="form" property="zip" />
        </b-col>
        <b-col v-if="!is_crypto" md="4">
          <input-component label="Phone"  @update="focusOut($event,'phone')" :form="form" property="phone" />
        </b-col>
        <b-col v-if="is_crypto" md="4">
          <input-component label="Cell Phone"  @update="focusOut($event,'cell_phone')" :form="form" property="cell_phone" />
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col v-if="!is_crypto" md="4">
          <input-component label="Cell Phone"  @update="focusOut($event,'cell_phone')" :form="form" property="cell_phone" />
        </b-col>
        <b-col md="4">
          <input-component label="Fax" :form="form" property="fax" />
        </b-col>
      </b-row>

      <md-button @click="submit" class="md-primary md-raised c-primary ml-0">
        <template v-if="id">Save</template>
        <template v-else>Create</template>
      </md-button>
    </form>
  </div>
</template>
<script>
export default {
  props: ["id"],
  data() {
    return {
      is_crypto: (process.env.VUE_APP_SYSTEM == "crypto") ? true : false,
      states: [],
      subroles: [],
      submitting: false,
      form: new Form({
        first_name: "",
        last_name: "",
        subrole_id: "",
        email: "",
        street: "",
        city: "",
        state_id: "",
        zip: "",
        cell_phone: "",
        phone: "",
        fax: ""
      })
    };
  },
  mounted() {
    // if id is provided then the user is editing  (load the user from backend)
    if (this.id) {
      axios.get("/lmt/get-user?id=" + this.id).then(({ data }) => {
        this.form.first_name = data.user.first_name;
        this.form.last_name = data.user.last_name;
        this.form.subrole_id = data.user.subrole_id;
        this.form.email = data.user.email;
        this.form.street = data.user.street;
        this.form.city = data.user.city;
        this.form.state_id = data.user.state_id;
        this.form.zip = data.user.zip;
        this.form.phone = data.user.phone;
        this.form.cell_phone = data.user.cell_phone;
        this.form.fax = data.user.fax;
      });
    }

    //load the states for filling the select box
    axios.get("/states").then(({ data }) => {
      this.states = data.states;
    });

    //load the roles for filling the select box
    axios.get("/user/subroles").then(({ data }) => {
      this.subroles = data.subroles;
    });
  },
  methods: {
    //when the user try to store the provided data
    submit() {
      //set the correct url for creating or editing
      let url = this.id ? "/lmt/staff/store/" + this.id : "/lmt/staff/store";

      var $this = this;
      this.submitting = true;
      $this.form
        .submit("post", url)
        .then(data => {
          Event.$emit("message", [data.message]);
          $this.$router.push("/lmt/staff");
        })
        .catch(error => {
          this.submitting = false;
          console.log(error);
        });
    },
     focusOut: function(event,f) {
      if (["Arrow", "Backspace", "Shift"].includes(event.key)) {
        this.preventNextIteration = true;
        return;
      }
      if (this.preventNextIteration) {
        this.preventNextIteration = false;
        return;
      }
      let formattedPhoneValue = 0 ;
     
      formattedPhoneValue =  this.form[f]
        .replace(/-/g, "")
        .match(/(\d{1,10})/g)[0];

      // Format display value based on calculated currencyValue
      this.form[f] = formattedPhoneValue.replace(
        /(\d{1,3})(\d{1,3})(\d{1,4})/g,
        "$1-$2-$3"
      );
    }

  }
};
</script>